export const collectionsPage = {
    'collections.page.title': '收藏',
    'collections.page.bonus.toy.description': '要获取这个特别的玩具，您需要通过收集系列中的所有其他玩具来完成整个收藏。一旦您收集齐了该系列中的每一件物品，这个独特的玩具将作为奖励解锁，象征着您完成整个收藏的成就。',
    'collections.page.trending.collections.title': '热门收藏',
}
